import * as React from "react";

import { Modal } from "react-bootstrap/lib";

interface IModal { 
    initRef: Function,
    title: string,
    bsSize?: "sm" | "xs"
}
class CModal extends React.Component<IModal, any> {
    constructor(props: IModal) {
        super(props);

        this.state = {
            show: false
        };
    }

    componentDidMount() {
        this.props.initRef(this);
    }

    handleClose = () => {
        this.setState({ show: false });
    }

    handleShow = () => {
        this.setState({ show: true });
    }

    render() {
        return (
            <Modal bsSize={this.props.bsSize} show={this.state.show} onHide={this.handleClose}>
                <Modal.Header closeButton>
                    { this.props.title }
                </Modal.Header>
                <Modal.Body>
                    { this.props.children || "" }
                </Modal.Body>
            </Modal>
        );
    }
}

export default CModal;


// WEBPACK FOOTER //
// ./src/components/modal/Modal.tsx